import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://food-science-safety-ready.impultienda.ar/checkout';
function trackCheckout() {
  if (typeof window !== 'undefined') {
    const pixel = window as Window & {
      fbq?: (event: string, name: string, data: Record<string, string | number>) => void;
    };
    pixel.fbq?.('track', 'InitiateCheckout', {
      content_name: 'Food Science Teacher Ready Complete Teaching Library',
      value: 27,
      currency: 'USD'
    });
  }
}
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-140" data-mp="sa9rfbp63pvl">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-141" data-mp="ncq13df73mna" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-142" data-mp="3d2torapbqmf2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-143" data-mp="381nuv9jxgt3y">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-144" data-mp="3o7vgxbbup7t2">
            📚 Food Science Teacher Ready™
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-145" data-mp="3eb8zkwiqgyvs">
            Solve a Full Year of Food Science Classes in Just{' '}
            <span className="text-gold-gradient" data-id="element-146" data-mp="35aucpsq4fbq6">5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-147" data-mp="2qhqudj4pgtye">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-148" data-mp="2ljgy1578vnb7" />
          <img src="https://cdn.magicpatterns.com/uploads/fKMtGsNg351me6sD44QLcZ/Diseno_sin_titulo_(41).png" alt="Food Science Teacher Ready complete teaching library for Grades 9–12" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-149" data-mp="s2b7hx6yyh4m" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-150" data-mp="de6mgmkg1tio">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-151" data-mp="162uf537ivl69">
            Food Science Teacher Ready™ — Complete Teaching Library. 90
            Ready-to-Teach Lessons for Grades 9–12, ready to use from today.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-152" data-mp="3ltgltmwy8kmr">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-153" data-mp="3lqudvm65c340">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-154" data-mp="218tq5wogtcfe">
            <div className="flex items-center gap-1.5" data-id="element-155" data-mp="2686946c7tzcp">
              <CheckCircle size={14} className="text-gold" data-id="element-156" data-mp="2b1hiae4i2s7s" />
              <span data-id="element-157" data-mp="2g02iwennzdwr">Premium Teaching Library</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-158" data-mp="2g1wu3194vrnn">
              <CheckCircle size={14} className="text-gold" data-id="element-159" data-mp="2kxucdd3yj832" />
              <span data-id="element-160" data-mp="2p0h7bmvxd94h">5 Strategic Bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-161" data-mp="2p10imkr2kz9j">
              <CheckCircle size={14} className="text-gold" data-id="element-162" data-mp="2u03kjwbr6pda" />
              <span data-id="element-163" data-mp="2txhbfs97s1sy">Immediate Access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}